<template>
  <v-container fluid>
    <v-row v-if="!loadingSave" justify="center">
      <v-col cols="12">
        <!-- Page Header -->
        <v-row align="center" justify="center" class="mt-n4">
          <v-col cols="12" md="auto">
            <div class="d-flex align-center justify-center">
              <v-avatar color="primary" size="52" class="mr-3 elevation-2">
                <v-icon color="white" size="28">mdi-file-document-outline</v-icon>
              </v-avatar>
              <div>
                <div class="text-h5 font-weight-bold grey--text text--darken-2">Factura Proveedores</div>
                <div class="text-caption grey--text">Consulta y gestiona las facturas de proveedores</div>
              </div>
            </div>
          </v-col>
        </v-row>

        <!-- Filters -->
        <v-row justify="center">
          <v-col cols="12">
            <search-header-po @dataFilters="changeBusiness($event)" />
          </v-col>
        </v-row>
        <v-row align="center" justify="center" class="pb-2">
          <v-col md="3" class="pt-0">
            <v-row>
              <v-col md="6">
                <v-autocomplete v-model="invoice_category" outlined dense hide-details :items="item_categories"
                  label="Categoria"></v-autocomplete>
              </v-col>
              <v-col md="6">
                <v-autocomplete v-model="currency_filter" outlined dense hide-details :items="[
                  { value: 0, text: 'Todas' },
                  { value: 1, text: 'DOP' },
                  { value: 2, text: 'HTG' },
                  { value: 3, text: 'USD' },
                  { value: 4, text: 'EUR' },
                ]" label="Moneda"></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>

          <v-col md="2" class="pt-0">
            <v-autocomplete v-model="customer_filter" outlined dense hide-details :items="customers"
              label="Suplidor"></v-autocomplete>
          </v-col>
          <v-col md="2" class="pt-0">
            <v-autocomplete v-model="branche_filter" outlined dense :disabled="customer_filter < 0" hide-details
              :items="branches" label="Sucursal"></v-autocomplete>
          </v-col>
        </v-row>
        <v-card class="rounded-lg mt-n3">
          <v-expand-transition>
            <v-row v-if="loading" justify="center">
              <v-col cols="12" md="10">
                <v-skeleton-loader type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions">
                </v-skeleton-loader>
              </v-col>
            </v-row>
            <v-data-table v-else height="50vh" :headers="headers" :items-per-page="itemsPerPage" :items="invoices"
              :server-items-length="totalItems" class="elevation-0" dense fixed-header hide-default-footer>
              <template v-slot:top>
                <v-toolbar class="elevation-0 rounded-lg">
                  <v-toolbar-title>Activas:
                    {{ currencyFormat(invoices_status.actives).split(".")[0] }} |
                    Inactivas:
                    {{
                      currencyFormat(invoices_status.inactives).split(".")[0]
                    }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-col md="4">
                    <v-text-field label="Buscar por factura o suplidor..." class="mt-0" v-model="search" outlined dense
                      hide-details clearable append-icon="mdi-magnify" @click:clear="onSearchClear"
                      @keyup.enter="triggerSearch" @click:append="triggerSearch"></v-text-field>
                  </v-col>
                  <v-spacer></v-spacer>
                  <v-menu bottom origin="center center" transition="scale-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="mr-2 mt-n2" color="success" dark outlined v-bind="attrs" v-on="on">
                        <v-icon class="ml-2">mdi-download</v-icon>
                      </v-btn>
                    </template>

                    <v-list>
                      <v-list-item @click="downloadPDF" disabled>
                        <v-list-item-icon>
                          <v-icon color="red">mdi-file-pdf-box</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>PDF</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="save_csv(1)">
                        <v-list-item-icon>
                          <v-icon color="success">mdi-file-excel-box</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Detallado excel</v-list-item-title>
                      </v-list-item>
                      <v-list-item @click="save_csv(2)">
                        <v-list-item-icon>
                          <v-icon color="success">mdi-file-excel-box</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>Agrupado excel</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-dialog transition="slide-x-transition" v-model="dialog" fullscreen>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-if="hasFeature('SHOP-163')" @click="showNew" color="primary" dark class="mb-2" outlined>
                        <v-icon small>add</v-icon>
                        Nueva factura
                      </v-btn>
                    </template>
                    <v-card style="background-color: #f4f5fa">
                      <v-row justify="center">
                        <v-col cols="12" md="12" lg="12" xl="12">
                          <invoice v-if="dialog" :type="1" :editOrCopy="editedItem" :itbis="itbis"
                            :credit_days="credit_days" :ncfTypes="ncfTypes" :withholdings="withholdings" :boxes="boxes"
                            :accounts="accounts" :itemsLocations="itemsLocations"
                            :invoice_categories="invoice_categories" :itemsDepartments="itemsDepartments"
                            :editOrCopyStatus="editOrCopyStatus" @close-dialog="clear()" @save-invoice="save($event)" />
                        </v-col>
                      </v-row>

                      <v-card-text> </v-card-text>
                    </v-card>
                  </v-dialog>
                  <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                      <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                        <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                        <v-spacer></v-spacer>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-badge color="red" overlap dot :value="user_group.length > 0">
                    <v-btn icon class="pb-2" @click="dialog_settings = true"><v-icon>settings</v-icon></v-btn>
                  </v-badge>
                  <!-- <v-btn icon class="pb-3" @click="dialog_settings=true"><v-icon>settings</v-icon></v-btn> -->
                </v-toolbar>
              </template>
              <template v-slot:[`item.invoice_number`]="{ item }">
                <v-hover v-slot="{ hover }">
                  <span @click="showInvoice(item.invoice_id, true)"
                    class="primary--text font-weight-normal text-truncate font-weight-semibold" :style="{
                      color: hover ? 'red' : 'black',
                      cursor: hover ? 'pointer' : '',
                      'text-decoration': hover ? 'underline' : '',
                    }">
                    <span class="red--text d-flex" v-if="item.invoice_type_id == 5">
                    </span>

                    {{ item.invoice_number }}

                    <v-icon v-if="item.box_id">mdi-point-of-sale</v-icon>
                    <br />
                    {{ item.invoice_ncf }}
                  </span>
                </v-hover>
                <br />
              </template>
              <template v-slot:[`item.supplier_invoice_number`]="{ item }">
                <div class="d-flex flex-column" style="line-height: 1.2;">
                  <span v-if="getSupplierNumberDisplay(item) !== '-'" class="text-caption font-weight-medium">
                    {{ getSupplierNumberDisplay(item) }}
                  </span>
                  <v-chip
                    v-if="getSupplierVoucherDisplay(item)"
                    x-small label
                    color="orange lighten-5"
                    text-color="orange darken-2"
                    class="mt-1 font-weight-bold"
                    style="max-width: 100%;"
                  >
                    <v-icon left x-small>mdi-file-certificate</v-icon>
                    {{ getSupplierVoucherDisplay(item) }}
                  </v-chip>
                  <span v-if="getSupplierNumberDisplay(item) === '-' && !getSupplierVoucherDisplay(item)" class="grey--text text-caption">
                    -
                  </span>
                </div>
              </template>
              <template v-slot:[`item.total_amount`]="{ item }">
                <span>
                  {{ currencyFormat(item.total_amount) }}
                  {{ item.currency_code }}</span>
              </template>
              <template v-slot:[`item.total_paid`]="{ item }">
                <span>
                  {{ currencyFormat(item.total_paid) }}
                  {{ item.currency_code }}</span>
              </template>
              <template v-slot:[`item.pending_amount`]="{ item }">
                <span>
                  {{ currencyFormat(item.pending_amount) }}
                  {{ item.currency_code }}</span>
              </template>

              <template v-slot:[`item.entity_name`]="{ item }">
                <v-hover v-slot="{ hover }">
                  <span @click="viewEntity(item.entity_id)" style="font-size: 14px"
                    class="primary--text font-weight-normal text-truncate font-weight-semibold" :style="{
                      color: hover ? 'red' : 'black',
                      cursor: hover ? 'pointer' : '',
                      'text-decoration': hover ? 'underline' : '',
                    }">{{ item.entity_name.slice(0, 25) }}</span></v-hover>
              </template>
              <template v-slot:[`item.recorded`]="{ item }">
                <v-icon color="success" v-if="item.recorded">verified</v-icon>
                <v-icon :color="item.invoice_type_id != 5 ? 'warning' : 'grey lighten-1'" v-else>{{ item.invoice_type_id
                  == 5 ? "block" : "cancel" }}</v-icon>
                <!-- <v-chip small color="success" v-if="item.recorded">
                  <span>SI </span>
                </v-chip> -->
                <!-- <v-chip
                  small
                  :color="item.invoice_type_id != 5 ? 'warning' : 'grey lighten-1'"
                  v-else
                >
                <v-icon>{{  item.invoice_type_id == 5 ? 'block':'cancel' }}</v-icon>
                  <span class="text--primary">{{
                    item.invoice_type_id == 5
                      ? "NO"
                      : "NO"
                  }}</span>
                </v-chip> -->
              </template>
              <template v-slot:[`item.status_id`]="{ item }">
                <v-chip small outlined color="success" v-if="item.status_id == 1">
                  Activa
                </v-chip>
                <v-chip small outlined color="red" v-else> Anulada </v-chip>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-if="item.invoice_type_id != 5 && hasFeature('SHOP-163')" v-bind="attrs" v-on="on" color="primary"
                      @click="editItem(item, true)" large>
                      read_more
                    </v-icon>
                  </template>
                  <span>Copiar</span>
                </v-tooltip>
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon v-if="!item.recorded && item.status_id == 1 && hasFeature('SHOP-164')" v-bind="attrs" v-on="on" medium color="warning"
                      class="mx-1" @click="editItem(item, false)">edit</v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
              </template>
              <template v-slot:no-data>
                <v-row justify="center" class="pt-10">
                  <v-icon size="80px">token</v-icon>
                </v-row>
                <v-row justify="center" class="pb-6"> No hay datos </v-row>
              </template>
              <template slot="footer">
                <v-divider></v-divider>
                <div class="pa-4">
                  <v-row justify="center" align="center">
                    <v-col cols="auto">
                      <v-pagination v-model="page" :length="pageCount" :total-visible="7" color="primary" circle
                        @input="onPageChange"></v-pagination>
                    </v-col>
                  </v-row>
                </div>
              </template>
            </v-data-table>
          </v-expand-transition>
        </v-card>
        <v-card>
          <v-row justify="end" align="center">
            <v-col cols="12" md="1">
              <span class="font-weight-bold" style="color: #607d8b; font-size: 15px">
                {{ total_currencies.length <= 1 ? "TOTAL" : "TOTALES" }}: </span>
            </v-col>
            <v-col md="2" v-for="currency in total_currencies" :key="currency.currency_code" align="center">
              <th style="font-size: 20px" class="font-weight-bold text-right success--text">
                {{ currencyFormat(currency.total_amount) }}
                {{ currency.currency_code }}
              </th>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>

    <v-dialog v-model="dialog_settings" width="900" scrollable>
      <v-card class="rounded-lg">
        <v-toolbar flat dense color="primary" dark>
          <v-icon left small>mdi-filter-variant</v-icon>
          <v-toolbar-title class="text-body-1 font-weight-bold">Filtros y búsqueda de compras</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialog_settings = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-0" style="max-height: 75vh;">
          <!-- ===== Sección: Agrupar por usuarios ===== -->
          <div class="px-5 py-4">
            <div class="d-flex align-center mb-2">
              <v-icon small color="grey darken-1" class="mr-2">mdi-account-group-outline</v-icon>
              <span class="text-subtitle-2 font-weight-bold grey--text text--darken-2">Agrupar por usuarios</span>
              <v-spacer></v-spacer>
              <v-chip v-if="user_group.length > 0" x-small label color="primary lighten-5" text-color="primary">
                {{ user_group.length }} seleccionado(s)
              </v-chip>
            </div>
            <v-autocomplete
              v-model="user_group"
              outlined multiple dense chips small-chips deletable-chips
              hide-details
              no-data-text="No hay usuarios disponibles"
              :items="users"
              label="Usuarios"
              prepend-inner-icon="mdi-account-multiple"
              clearable
            ></v-autocomplete>
          </div>

          <v-divider></v-divider>

          <!-- ===== Sección: Búsqueda de facturas ===== -->
          <div class="px-5 py-4">
            <div class="d-flex align-center mb-2">
              <v-icon small color="grey darken-1" class="mr-2">mdi-magnify</v-icon>
              <span class="text-subtitle-2 font-weight-bold grey--text text--darken-2">Buscar factura de compra</span>
              <v-spacer></v-spacer>
              <v-btn v-if="invoices_found.length > 0 || search_invoice || search_invoice_with_supplier_code || search_invoice_with_supplier_voucher"
                x-small text color="grey darken-1" @click="clearInvoiceSearch">
                <v-icon left x-small>mdi-broom</v-icon> Limpiar
              </v-btn>
            </div>
            <div class="text-caption grey--text mb-2">
              <v-icon x-small class="mr-1">mdi-information-outline</v-icon>
              Busca por uno de los tres criterios. La búsqueda es flexible (ILIKE).
            </div>
            <v-alert v-if="!hasSingleBusinessUnitSelected" type="warning" dense text border="left" class="mb-3 text-caption">
              <v-icon left x-small>mdi-alert</v-icon>
              <strong>Selecciona una Unidad de Negocio específica</strong> en los filtros principales. Sin esto, dos proveedores distintos pueden tener el mismo eNCF en diferentes unidades y los resultados se cruzan.
            </v-alert>
            <v-alert v-else type="info" dense text border="left" class="mb-3 text-caption">
              <v-icon left x-small>mdi-domain</v-icon>
              Buscando en: <strong>{{ currentBusinessUnitName }}</strong>
            </v-alert>

            <v-row dense>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="search_invoice"
                  label="Número de factura"
                  placeholder="Ej: FC0010000123"
                  prepend-inner-icon="mdi-receipt-text"
                  v-on:keyup.enter="find_invoice(1)"
                  @input="onSearchInputChange('invoice')"
                  dense outlined hide-details
                  :disabled="loading_search_invoice"
                  :loading="loading_search_invoice"
                  clearable
                  append-icon="mdi-magnify"
                  @click:append="find_invoice(1)"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="search_invoice_with_supplier_code"
                  label="No. Factura del suplidor"
                  placeholder="Ej: 12345-A"
                  prepend-inner-icon="mdi-domain"
                  v-on:keyup.enter="find_invoice(2)"
                  @input="onSearchInputChange('supplier_code')"
                  dense outlined hide-details
                  :disabled="loading_search_invoice"
                  :loading="loading_search_invoice"
                  clearable
                  append-icon="mdi-magnify"
                  @click:append="find_invoice(2)"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  v-model="search_invoice_with_supplier_voucher"
                  label="Comprobante (eNCF) del suplidor"
                  placeholder="Ej: E310000000123"
                  prepend-inner-icon="mdi-file-certificate"
                  v-on:keyup.enter="find_invoice(3)"
                  @input="onSearchInputChange('supplier_voucher')"
                  dense outlined hide-details
                  :disabled="loading_search_invoice"
                  :loading="loading_search_invoice"
                  clearable
                  append-icon="mdi-magnify"
                  @click:append="find_invoice(3)"
                ></v-text-field>
              </v-col>
            </v-row>

            <!-- Tabla de resultados -->
            <div v-if="invoices_found.length > 0" class="mt-4">
              <div class="d-flex align-center mb-2">
                <v-chip x-small label color="success lighten-5" text-color="success" class="font-weight-bold">
                  <v-icon left x-small>mdi-check-circle</v-icon>
                  {{ invoices_found.length }} resultado(s)
                </v-chip>
              </div>
              <v-simple-table dense class="rounded-lg" style="border: 1px solid #e0e0e0;">
                <template v-slot:default>
                  <thead>
                    <tr style="background-color: #f5f7fa">
                      <th class="text-left" style="font-size: 11px;">Factura</th>
                      <th class="text-left" style="font-size: 11px;">No. Suplidor</th>
                      <th class="text-left" style="font-size: 11px;">eNCF Suplidor</th>
                      <th class="text-left" style="font-size: 11px;">Fecha</th>
                      <th class="text-left" style="font-size: 11px;">Suplidor</th>
                      <th class="text-right" style="font-size: 11px;">Monto</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in invoices_found" :key="item.invoice_id" dense>
                      <td>
                        <v-hover v-slot="{ hover }">
                          <span @click="showInvoice(item.invoice_id, true); dialog_settings = false"
                            class="primary--text font-weight-medium" :style="{
                              color: hover ? '#1976d2' : '#1565c0',
                              cursor: 'pointer',
                              'text-decoration': hover ? 'underline' : 'none',
                            }">
                            {{ item.invoice_number }}
                          </span>
                        </v-hover>
                      </td>
                      <td class="text-caption">{{ getSupplierNumberDisplay(item) }}</td>
                      <td class="text-caption">
                        <v-chip v-if="getSupplierVoucherDisplay(item)" x-small label color="orange lighten-5" text-color="orange darken-2">
                          {{ getSupplierVoucherDisplay(item) }}
                        </v-chip>
                        <span v-else class="grey--text">-</span>
                      </td>
                      <td class="text-caption">{{ item.emission_date }}</td>
                      <td class="text-caption">{{ item.entity_name }}</td>
                      <td class="text-right font-weight-bold">{{ currencyFormat(item.total_amount) }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </div>

            <!-- Empty state cuando no hay búsqueda activa -->
            <v-card
              v-else-if="!loading_search_invoice && !search_invoice && !search_invoice_with_supplier_code && !search_invoice_with_supplier_voucher"
              flat color="grey lighten-5" class="mt-4 pa-4 text-center rounded-lg"
            >
              <v-icon size="36" color="grey lighten-1">mdi-file-search-outline</v-icon>
              <div class="text-caption grey--text mt-2">Ingresa un criterio de búsqueda</div>
            </v-card>

            <!-- Loading state -->
            <v-card v-else-if="loading_search_invoice" flat class="mt-4 pa-4 text-center">
              <v-progress-circular indeterminate color="primary" size="24"></v-progress-circular>
              <div class="text-caption grey--text mt-2">Buscando...</div>
            </v-card>
          </div>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions class="px-5 py-3">
          <v-btn text small color="grey darken-1" @click="(user_group = []), clearInvoiceSearch(), (dialog_settings = false)">
            <v-icon left small>mdi-close</v-icon> Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small color="primary" depressed @click="dialog_settings = false">
            <v-icon left small>mdi-check</v-icon> Aplicar filtros
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import moment from "moment";
export default {
  data: () => ({
    loadingSave: false,
    editOrCopyStatus: false,
    page: 1,
    pageCount: 0,
    totalItems: 0,
    itemsPerPage: 50,
    search: "",
    searchTimeout: null,
    search_invoice: null,
    loading_search_invoice: false,
    invoices_found: [],
    search_invoice_with_supplier_code: null,
    search_invoice_with_supplier_voucher: null,
    loading: false,
    invoice_type: 0,
    invoice_category: 0,
    item_categories: [
      { value: 0, text: "Todo" },
      { value: 1, text: "Contado/efectivo" },
      { value: 2, text: "Credito" },
    ],
    currency_filter: 0,
    box_filter: 0,
    customer_filter: -1,
    branche_filter: -1,
    user_group: [],
    currencies: [],
    dialog: false,
    loading_bonos: false,
    dialogDelete: false,
    dialog_settings: false,
    suplidor: false,
    cliente: false,
    disabledName: false,
    plazoPagoSuplidor: null,
    plazoPagoCliente: null,
    documents: [],
    rncValid: false,
    ncfTypes: [],
    accounts: [],
    provincies: [],
    invoices: [],
    itemsLocations: [],
    itemsDepartments: [],
    cxc: "",
    cxp: "",
    itbis: [],
    credit_days: [],

    invoice_categories: [],
    withholdings: [],
    boxes: [],
    selectedDocument: "",
    selectedtypesNcfCliente: "",
    selectedtypesNcfSuplidor: "",
    selectedProvincies: "",
    headers: [
      {
        text: "Factura",
        align: "start",
        value: "invoice_number",
      },

      //  { text: "Location", value: "location_description" },
      { text: "COD. SUP", value: "supplier_invoice_number" },
      { text: "Fecha", value: "emission_date" },
      { text: "Suplidor", value: "entity_name" },
      //   { text: "Sucursal", value: "branch", width: "12%" },
      { text: "Monto", value: "total_amount", align: "end" },
      //  { text: "Pagado", value: "total_paid", align: "end" },
      //{ text: "Pendiente", value: "pending_amount", align: "end" },
      { text: "Usuario", value: "user_name", align: "end" },
      { text: "Status", value: "status_id" },
      { text: "Contabilizada", value: "recorded", align: "center" },
      { text: "Actions", value: "actions" },

      //{ text: "Actions", value: "actions", sortable: false },
    ],
    lastFilters: {},
    editedIndex: -1,
    quotation_id: null,
    editedItem: {},
  }),
  computed: {
    hasSingleBusinessUnitSelected() {
      const bu = this.lastFilters && this.lastFilters.business;
      return !!bu && bu !== 0 && !Array.isArray(bu);
    },
    currentBusinessUnitName() {
      const bu = this.lastFilters && this.lastFilters.business;
      if (!bu || bu === 0) return "Todas las unidades";
      if (Array.isArray(bu)) return `${bu.length} unidades`;
      const units = (this.$store && this.$store.state && this.$store.state.auth && this.$store.state.auth.bussines_units) || [];
      const found = units.find((u) => u.value === bu || u.id === bu);
      return found ? (found.text || found.description_long || found.name || `Unidad #${bu}`) : `Unidad #${bu}`;
    },
    total_currencies() {
      const grouped = this.invoices.reduce((acc, invoice) => {
        // Verificar si el status_id es 1
        if (invoice.status_id !== 1) {
          return acc; // Si no es 1, saltar esta factura
        }

        // Verificar si ya existe un objeto para la moneda en el acumulador
        let currencyGroup = acc.find(
          (item) => item.currency_code === invoice.currency_code
        );

        // Si no existe, agregar un nuevo objeto para esa moneda
        if (!currencyGroup) {
          acc.push({
            currency_code: invoice.currency_code,
            total_amount: 0,
          });
          currencyGroup = acc[acc.length - 1]; // Actualizar la referencia
        }

        // Sumar el monto total, asegurándote de convertirlo a número
        currencyGroup.total_amount += parseFloat(invoice.total_amount);
        return acc;
      }, []);
      return grouped;
    },
    invoices_status() {
      const actives = this.invoices.filter((element) => element.status_id == 1);
      return {
        actives: actives.length,
        inactives: this.invoices.length - actives.length,
      };
    },
    boxes_computed() {
      // Filtrar duplicados y mapear a la estructura deseada
      let uniqueBoxes = this.invoices.reduce((acc, invoice) => {
        // Buscar si el box_id ya está en el acumulador
        if (!acc.some((box) => box.value === invoice.box_id)) {
          acc.push({
            text: invoice.box_name, // Nombre de la caja
            value: invoice.box_id, // ID de la caja
          });
        }
        return acc;
      }, []);
      uniqueBoxes.unshift({ text: "Todas", value: 0 });
      return uniqueBoxes;
    },
    customers() {
      // Filtrar duplicados y mapear a la estructura deseada
      const uniqueClients = this.invoices.reduce((acc, invoice) => {
        // Buscar si el entity_id ya está en el acumulador
        if (!acc.some((client) => client.value === invoice.entity_id)) {
          acc.push({
            text: invoice.entity_name, // Nombre del cliente
            value: invoice.entity_id, // ID del cliente
          });
        }
        return acc;
      }, []);
      uniqueClients.unshift({ text: "Todos", value: -1 });
      return uniqueClients;
    },
    branches() {
      if (this.customer_filter < 0) {
        return [];
      }
      // Filtrar duplicados y mapear a la estructura deseada
      const uniqueBranche = this.invoices
        .filter((element) => element.entity_id == this.customer_filter)
        .reduce((acc, invoice) => {
          // Buscar si el entity_branch_id ya está en el acumulador
          if (!acc.some((branch) => branch.value === invoice.entity_branch_id)) {
            acc.push({
              text: invoice.branch, // Nombre de la sucursal
              value: invoice.entity_branch_id, // ID de la sucursal
            });
          }
          return acc;
        }, []);
      uniqueBranche.unshift({ text: "Todos", value: -1 });
      return uniqueBranche;
    },
    box_totals() {
      // Crear un objeto acumulador que agrupe por caja y moneda
      const totals = this.invoices.reduce((acc, invoice) => {
        // Verificar que la factura tenga status_id == 1 (activa)
        if (invoice.status_id === 1) {
          // Clave para combinar box_name y currency_code
          const key = `${invoice.box_name}-${invoice.currency_code}`;

          // Si la clave no existe en el acumulador, inicializarla
          if (!acc[key]) {
            acc[key] = {
              box_name: invoice.box_name, // Nombre de la caja
              currency_code: invoice.currency_code, // Código de moneda
              total: 0, // Iniciar el total en 0
            };
          }
          // Sumar el total_amount (convertir a número)
          acc[key].total += parseFloat(invoice.total_amount);
        }

        return acc;
      }, {});

      // Retornar los valores y ordenar por box_name
      return Object.values(totals).sort((a, b) => a.box_name.localeCompare(b.box_name));
    },
    users() {
      const uniqueUsers = this.invoices.reduce((acc, invoice) => {
        if (!acc.some((users) => users.value === invoice.user)) {
          acc.push({
            text: invoice.user,
            value: invoice.user_id,
          });
        }
        return acc;
      }, []);
      return uniqueUsers;
    },
  },
  watch: {
    currency_filter() {
      if (this.lastFilters && Object.keys(this.lastFilters).length > 0) {
        this.getData(this.lastFilters, true);
      }
    },
    box_filter() {
      if (this.lastFilters && Object.keys(this.lastFilters).length > 0) {
        this.getData(this.lastFilters, true);
      }
    },
    customer_filter() {
      if (this.lastFilters && Object.keys(this.lastFilters).length > 0) {
        this.getData(this.lastFilters, true);
      }
    },
    branche_filter() {
      if (this.lastFilters && Object.keys(this.lastFilters).length > 0) {
        this.getData(this.lastFilters, true);
      }
    },
    invoice_category() {
      if (this.lastFilters && Object.keys(this.lastFilters).length > 0) {
        this.getData(this.lastFilters, true);
      }
    },
    user_group() {
      if (this.lastFilters && Object.keys(this.lastFilters).length > 0) {
        this.getData(this.lastFilters, true);
      }
    },
  },
  created() {
    this.init();
  },
  methods: {
    showNew() {
      this.quotation_id = null;
      this.editedItem = {};
      this.editOrCopyStatus = false;
      this.dialog = true;
    },
    downloadPDF() { },
    async init() {

      const result = await Promise.all([
        this.api_Get("accounting/taxes"),
        this.api_Get("accounting/accountsUsable"),
        this.api_Get("humanResource/locations"),
        this.api_Get("income/boxes"),
        this.api_Get("accounting/withholdings"),
        this.api_Get("income/invoice_categories"),
        this.api_Get("accounting/nfc_types"),
        this.api_Get("accounting/credit_days"),

        this.g_departments(),
      ]);

      this.itbis = await result[0].json();

      for (let item of await result[1].json()) {
        this.accounts.push({
          text: item.code + " - " + item.name,
          value: item.id,
          id: item.id,
          dgii_category_id: item.dgii_category_id,
        });
      }
      for (let item of await result[2].json()) {
        for (let item2 of this.$store.state.auth.locations) {
          if (item2.id == item.id) {
            this.itemsLocations.push({
              value: item.id,
              text: item.desc_loc_long,
              id: item.id,
              bus_id: item.bus_id,
              desc_bus_short: item.desc_bus_short,
              desc_bus_long: item.desc_bus_long,
              desc_loc_short: item.desc_loc_short,
              desc_loc_long: item.desc_loc_long,
              city_id: item.city_id,
              city_description: item.city_description,
              location_adress: item.location_adress,
              status_id: item.status_id,
              catalogue_id: item.catalogue_id,
              catalogue_name: item.catalogue_name,
              rnl: item.rnl,
              representative_name: item.representative_name,
              sta_description: item.sta_description,
              employee_representative_id: item.employee_representative_id,
            });
          }
        }
      }
      this.boxes = await result[3].json();
      this.withholdings = await result[4].json();
      this.invoice_categories = await result[5].json();
      this.ncfTypes = await result[6].json();
      this.ncfTypes.unshift({ id: 0, name: "SIN COMPROBANTE" });
      this.credit_days = await result[7].json();
      this.itemsDepartments = await result[8];
    },
    async getData(data, resetPage = true) {
      this.lastFilters = data;
      this.loading = true;

      if (resetPage) {
        this.page = 1;
      }

      const requestBody = {
        page: this.page,
        limit: this.itemsPerPage,
        sortBy: 'i.invoice_number',
        sortDesc: true,
        business: data.business || null,
        location: data.location || 0,
        department_id: data.department_id || 0,
        dateStart: data.dateStart,
        dateEnd: data.dateEnd,
        currency_filter: this.currency_filter || 0,
        box_filter: this.box_filter || 0,
        customer_filter: this.customer_filter >= 0 ? this.customer_filter : -1,
        branche_filter: this.branche_filter >= 0 ? this.branche_filter : -1,
        invoice_type: '1,4',
        invoice_category: this.invoice_category || 0,
        users: this.user_group.length > 0 ? this.user_group.join(',') : null,
        search: this.search ? this.search.replace(/['"]/g, '').trim() || null : null,
      };

      let resultInvoices = await this.api_Post("income/invoice_resume_list", requestBody);
      const response = await resultInvoices.json();
      this.invoices = response.data || [];

      const totalByStatus = response.total || [];
      this.totalItems = totalByStatus.reduce((sum, item) => sum + parseInt(item.total), 0);
      this.pageCount = Math.ceil(this.totalItems / this.itemsPerPage);

      for (let key in this.invoices) {
        const user = this.invoices[key].user.split(" ");
        this.invoices[key].user_name = `${user[0]} ${user[1]}`;
        if (
          this.invoices[key].supplier_invoice_number == null ||
          this.invoices[key].supplier_invoice_number.trim() == ""
        ) {
          this.invoices[key].supplier_invoice_number = "NO DEFINIDO";
        }
      }
      this.loading = false;
    },
    onPageChange() {
      if (this.lastFilters && Object.keys(this.lastFilters).length > 0) {
        this.getData(this.lastFilters, false);
      }
    },
    triggerSearch() {
      if (this.lastFilters && Object.keys(this.lastFilters).length > 0) {
        this.getData(this.lastFilters, true);
      }
    },
    onSearchClear() {
      this.search = "";
      if (this.lastFilters && Object.keys(this.lastFilters).length > 0) {
        this.getData(this.lastFilters, true);
      }
    },
    changeBusiness(data) {
      if (data.business == 0) {
        this.getData({
          business: this.$store.state.auth.user.acess_business_unit_finance,
          location: null,
          dateStart: data.dateStart,
          dateEnd: data.dateEnd,
        });
      } else {
        this.getData(data);
      }
    },
    clear() {
      this.editedItem = null;
      this.dialog = false;
    },
    async editItem(item, type) {
      this.editOrCopyStatus = true;
      this.quotation_id = null;
      const responseRequest = await this.api_Post("income/search_invoice_id", {
        number: item.invoice_id,
      });

      if (responseRequest.status == 200) {
        let invoice = await responseRequest.json();

        this.editedItem = Object.assign({}, invoice[0]);
        this.editedItem.is_editing = true;
        this.editedItem.nota = this.editedItem.note;

        let data = this.editedItem;
        if (type === true) {
          data.invoice_id = 0;
        }
      }

      this.dialog = true;
    },
    deleteItemConfirm() {
      this.entitys.splice(this.editedIndex, 1);
      this.closeDelete();
    },
    close() {
      this.dialog = false;

      this.$nextTick(() => {
        this.editedItem = [];
        this.editedIndex = -1;
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save(data) {
      this.loadingSave = true;

      this.getData(this.lastFilters);

      this.showInvoice(data[0].id, true);
      this.dialog = false;

      this.loadingSave = false;
    },
    async save_csv(report_type) {
      this.loading = true;
      try {
        const data = this.lastFilters;
        const requestBody = {
          business: data.business || null,
          location: data.location || 0,
          department_id: data.department_id || 0,
          dateStart: data.dateStart,
          dateEnd: data.dateEnd,
          currency_filter: this.currency_filter || 0,
          box_filter: this.box_filter || 0,
          customer_filter: this.customer_filter >= 0 ? this.customer_filter : -1,
          branche_filter: this.branche_filter >= 0 ? this.branche_filter : -1,
          invoice_type: '1,4',
          invoice_category: this.invoice_category || 0,
          users: this.user_group.length > 0 ? this.user_group.join(',') : null,
          report_type: report_type,
          search: this.search ? this.search.replace(/['"]/g, '').trim() || null : null,
        };

        const responseRequest = await this.api_Post("income/invoice_export_csv", requestBody);

        if (responseRequest.status != 200) {
          this.$toast.error("Error al generar el reporte");
          this.loading = false;
          return;
        }

        const result = await responseRequest.json();
        this.generateCsvFile(result.file_name, result.csv_data);
      } catch (error) {
        console.error(error.message);
        this.$toast.error("Error al descargar el reporte");
      } finally {
        this.loading = false;
      }
    },
    // type: 1 = invoice_number, 2 = supplier_invoice_number, 3 = supplier_invoice_voucher (eNCF del proveedor)
    async find_invoice(type) {
      try {
        this.loading_search_invoice = true;

        const location_access = this.itemsLocations.map((i) => i.id);
        if (location_access.length === 0) {
          this.$toast.error("No hay localidades disponibles para buscar");
          this.loading_search_invoice = false;
          return;
        }

        // Validar que haya una unidad de negocio específica seleccionada
        const businessSel = this.lastFilters && this.lastFilters.business;
        const isSingleUnit = businessSel && businessSel !== 0 && !Array.isArray(businessSel);
        if (!isSingleUnit) {
          this.$toast.error("Selecciona una Unidad de Negocio específica antes de buscar (cada proveedor puede repetir eNCF entre unidades)");
          this.loading_search_invoice = false;
          return;
        }

        const sanitize = (v) => (v == null ? "" : v.toString().replaceAll("'", "").replaceAll("%", "").trim());

        // type=1,2 → columnas que el endpoint ya selecciona (sin prefijo, igual que el código original).
        // type=3 → supplier_invoice_voucher NO está en el SELECT del endpoint invoice_sales_list,
        //         por eso se resuelve vía subquery que apunta directo a finances.invoices.
        let term = "";
        let whereClause = "";
        if (type == 1) {
          term = sanitize(this.search_invoice);
          whereClause = term ? `INVOICE_NUMBER ILIKE '%${term}%'` : "";
        } else if (type == 2) {
          term = sanitize(this.search_invoice_with_supplier_code);
          whereClause = term ? `SUPPLIER_INVOICE_NUMBER ILIKE '%${term}%'` : "";
        } else if (type == 3) {
          term = sanitize(this.search_invoice_with_supplier_voucher);
          // Buscar en supplier_invoice_voucher (correcto) Y en supplier_invoice_number
          // (algunos registros legacy tienen el eNCF guardado ahí).
          whereClause = term
            ? `(INVOICES.ID IN (SELECT id FROM finances.invoices WHERE supplier_invoice_voucher ILIKE '%${term}%') OR SUPPLIER_INVOICE_NUMBER ILIKE '%${term}%')`
            : "";
        } else {
          this.$toast.error("Tipo de búsqueda no válido");
          this.loading_search_invoice = false;
          return;
        }

        if (!term) {
          this.$toast.error("Búsqueda no válida: ingrese al menos un carácter");
          this.loading_search_invoice = false;
          return;
        }

        // Scope obligatorio por unidad de negocio: cada proveedor puede coincidir su eNCF
        // entre nuestras unidades; sin este filtro se cruzan resultados.
        const query =
          `WHERE ${whereClause}` +
          ` AND INVOICES.BUSINESS_UNIT_ID = ${parseInt(businessSel)}` +
          ` AND INVOICES.LOCATION_ID IN (${location_access.join(",")})`;

        const responseRequest = await this.api_Post("income/invoice_sales_list", { filters: query });

        if (responseRequest.status != 200) {
          this.$toast.error("Error al consultar la factura");
          this.loading_search_invoice = false;
          return;
        }

        const invoice = await responseRequest.json();
        if (!invoice || invoice.length === 0) {
          this.$toast.info("Factura no encontrada!");
          this.invoices_found = [];
          this.loading_search_invoice = false;
          return;
        }

        this.invoices_found = invoice;
        this.loading_search_invoice = false;
      } catch (error) {
        console.error(error.message);
        this.$toast.error(error.message);
        this.loading_search_invoice = false;
      }
    },

    clearInvoiceSearch() {
      this.search_invoice = null;
      this.search_invoice_with_supplier_code = null;
      this.search_invoice_with_supplier_voucher = null;
      this.invoices_found = [];
    },

    // Detecta si un valor parece eNCF (E + 10-12 dígitos) o NCF clásico (B/A + 10-12 dígitos)
    looksLikeEncf(value) {
      if (!value) return false;
      const v = value.toString().trim().toUpperCase();
      return /^E\d{10,12}$/.test(v);
    },

    // Voucher: usa supplier_invoice_voucher si viene; si no, intenta supplier_invoice_number cuando parece eNCF
    getSupplierVoucherDisplay(item) {
      if (item.supplier_invoice_voucher) return item.supplier_invoice_voucher;
      if (this.looksLikeEncf(item.supplier_invoice_number)) return item.supplier_invoice_number;
      return null;
    },

    // Número de suplidor: si el supplier_invoice_number es realmente un eNCF, no lo duplicamos en esta columna
    getSupplierNumberDisplay(item) {
      const num = item.supplier_invoice_number;
      if (!num) return "-";
      if (!item.supplier_invoice_voucher && this.looksLikeEncf(num)) return "-"; // se mostrará en columna eNCF
      return num;
    },

    // Mantener solo un criterio de búsqueda activo a la vez
    onSearchInputChange(field) {
      if (field !== "invoice") this.search_invoice = this.search_invoice;
      if (field === "invoice") {
        this.search_invoice_with_supplier_code = null;
        this.search_invoice_with_supplier_voucher = null;
      } else if (field === "supplier_code") {
        this.search_invoice = null;
        this.search_invoice_with_supplier_voucher = null;
      } else if (field === "supplier_voucher") {
        this.search_invoice = null;
        this.search_invoice_with_supplier_code = null;
      }
    },
  },
};
</script>

<style></style>
